var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncaLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 104,
    viewBox: "0 0 292 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 104,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_845_28",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 292,
    height: 104
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 104,
    fill: "url(#pattern1)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_845_28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28,
    y: -157,
    width: 236,
    height: 363,
    fill: "#556EE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_845_28",
    transform: "matrix(0.00636943 0 0 0.0178834 0 -0.000734934)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_845_28",
    transform: "matrix(0.00636943 0 0 0.0178834 0 -0.000734934)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_845_28",
    width: 157,
    height: 56,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncaLogoDark);
export default __webpack_public_path__ + "static/media/Inca-Logo-Dark.48ff3b3ff4e1d1a211cead4c9f37f48e.svg";
export { ForwardRef as ReactComponent };